// Data-tailor output formats. Lowercase values match the Platform OpenAPI enum
// (from the /data_tailor/extract spec). Labels shown in the Clip UI.
export type PublishFormat =
  | "shp"
  | "gpkg"
  | "gdb"
  | "geojson"
  | "tab"
  | "psv"
  | "csv";

export const FORMAT_LABELS: Record<PublishFormat, string> = {
  gpkg: "GeoPackage (.gpkg)",
  shp: "Shapefile (.shp)",
  gdb: "File Geodatabase (.gdb)",
  geojson: "GeoJSON (.geojson)",
  tab: "MapInfo TAB (.tab)",
  psv: "Pipe-Separated Values (.psv)",
  csv: "Comma-Separated Values (.csv)",
};

export const DEFAULT_FORMAT: PublishFormat = "shp";
